export const TemplateSectionFields = [
    [
        {
            childFields: [],
            field: "contactSalutationId",
            isRequired: false
        },
        {
            childFields: [],
            field: "contactFirstName",
            isRequired: true,
            maxLength: 100,
        },
        {
            childFields: [],
            field: "contactMiddleName",
            isRequired: false,
            maxLength: 100,
        },
        {
            childFields: [],
            field: "contactLastName",
            isRequired: false,
            maxLength: 100,
        },
        {
            childFields: [
                {
                    field: "contactWorkEmail",
                    isRequired: false,
                    maxLength: 100,
                },
                {
                    field: "contactHomeEmail",
                    isRequired: false,
                    maxLength: 100,
                },
                {
                    field: "contactCE1Email",
                    isRequired: false,
                    maxLength: 100,
                },
                {
                    field: "contactCE2Email",
                    isRequired: false,
                    maxLength: 100,
                }
            ],
        },
        {
            childFields: [
                {
                    field: "contactWorkPhone",
                    isRequired: false,
                },
                {
                    field: "contactMobilePhone",
                    isRequired: false,
                },
                {
                    field: "contactHomePhone",
                    isRequired: false,
                },
                {
                    field: "contactCP1Phone",
                    isRequired: false,
                },
                {
                    field: "contactCP2Phone",
                    isRequired: false,
                },
                {
                    field: "contactWorkPhoneCountry",
                    isRequired: false,
                },
                {
                    field: "contactWorkPhoneCode",
                    isRequired: false,
                },
                {
                    field: "contactMobilePhoneCountry",
                    isRequired: false,
                },
                {
                    field: "contactMobilePhoneCode",
                    isRequired: false,
                },
                {
                    field: "contactHomePhoneCountry",
                    isRequired: false,
                },
                {
                    field: "contactHomePhoneCode",
                    isRequired: false,
                },
                {
                    field: "contactCP1PhoneCountry",
                    isRequired: false,
                },
                {
                    field: "contactCP1PhoneCode",
                    isRequired: false,
                },
                {
                    field: "contactCP2PhoneCountry",
                    isRequired: false,
                },
                {
                    field: "contactCP2PhoneCode",
                    isRequired: false,
                },
            ],
        },
        {
            childFields: [
                {
                    field: "contactSocialTwitter",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "contactSocialFacebook",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "contactSocialLinkedIn",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "contactSocialInstagram",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "contactSocialWebsite",
                    isRequired: false,
                    maxLength: 500,
                }
            ],
        },
        {
            childFields: [],
            field: "contactProfileImages",
            isRequired: false
        },
        {
            childFields: [],
            field: "contactRoleId", //for contact Desgination
            isRequired: false
        },
        {
            childFields: [],
            field: "contactJobFunctionIds", //for contact Roles
            isRequired: false
        }
    ],
    [
        {
            childFields: [],
            field: "accountName",
            isRequired: false,
            maxLength: 100,
        },
        {
            childFields: [],
            field: "parentAccountId",
            isRequired: false
        },
        {
            childFields: [],
            field: "ownerId",
            isRequired: true
        },
        {
            childFields: [],
            field: "sequenceNumber",
            isRequired: true
        },
        {
            childFields: [],
            field: "accountTypeIds",
            isRequired: false
        },
        {
            childFields: [],
            field: "accountNumber",
            isRequired: false,
            maxLength: 50
        },
        {
            childFields: [],
            field: "timezoneId",
            isRequired: false
        },
        {
            childFields: [],
            field: "currencyId",
            isRequired: false
        },
        {
            childFields: [],
            field: "tags",
            isRequired: false
        }
    ],
    [
        {
            childFields: [],
            field: "doingBusinessAs",
            isRequired: false,
            maxLength: 50,
        },
        {
            childFields: [],
            field: "taxId",
            isRequired: false,
            maxLength: 50,
        },
        {
            childFields: [],
            field: "numberOfEmployeesId",
            isRequired: false
        },
        {
            childFields: [],
            field: "annualRevenueId",
            isRequired: false
        },
        {
            childFields: [],
            field: "ownershipTypeId",
            isRequired: false
        },
        {
            childFields: [],
            field: "stageId",
            isRequired: true
        },
        {
            childFields: [],
            field: "foundedYear",
            isRequired: false,
            maxLength: 15,
        },
        {
            childFields: [],
            field: "industryId",
            isRequired: false
        },
        {
            childFields: [],
            field: "accountEmail",
            isRequired: false,
            maxLength: 100,
        },
        {
            childFields: [],
            field: "accountPhone",
            isRequired: false,
        },
        {
            childFields: [],
            field: "accountPhoneCountry",
            isRequired: false,
        },
        {
            childFields: [],
            field: "accountPhoneCode",
            isRequired: false,
        },
        {
            childFields: [
                {
                    field: "accountSocialWebsite",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "accountSocialTwitter",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "accountSocialFacebook",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "accountSocialLinkedIn",
                    isRequired: false,
                    maxLength: 500,
                },
                {
                    field: "accountSocialInstagram",
                    isRequired: false,
                    maxLength: 500,
                }
            ],
            field: "accountSocial",
            isRequired: false
        },
        {
            childFields: [],
            field: "sicCode",
            isRequired: false
        },
        {
            childFields: [],
            field: "naicsCode",
            isRequired: false
        },
        {
            childFields: [],
            field: "accountSourceId",
            isRequired: false
        },
        {
            childFields: [],
            field: "ratingId",
            isRequired: false
        },
        {
            childFields: [],
            field: "notes",
            isRequired: false
        }
    ],
    [
        {
            childFields: [],
            field: "addressTypeId",
            isRequired: false
        },
        {
            childFields: [],
            field: "addressClassId",
            isRequired: false
        },
        {
            childFields: [],
            field: "streetAddress1",
            isRequired: false
        },
        {
            childFields: [],
            field: "streetAddress2",
            isRequired: false
        },
        {
            childFields: [],
            field: "countryId",
            isRequired: false
        },
        {
            childFields: [],
            field: "cityId",
            isRequired: false
        },
        {
            childFields: [],
            field: "stateId",
            isRequired: false
        },
        {
            childFields: [],
            field: "zipCode",
            isRequired: false
        },
        {
            childFields: [],
            field: "attnId",
            isRequired: false
        }
    ]
];
